import { render, staticRenderFns } from "./contentWP.vue?vue&type=template&id=094fb3ae"
import script from "./contentWP.ts?vue&type=script&lang=ts&external"
export * from "./contentWP.ts?vue&type=script&lang=ts&external"
import style0 from "./contentWP.vue?vue&type=style&index=0&id=094fb3ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports